import { createContext } from 'react';

type Config = {
  titlePrefix?: string;
};

export const context = createContext<Config>({});

export const HeadProvider = context.Provider;
